import { Common } from '../common';
import { Appointment } from '../models';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getPatientBookedAppointments(configurationId: string): Promise<{
    appointments: Appointment.Appointment[];
  }> {
    const url = this.common.constructPath(
      `/patient-previsit/appointments/booked`,
      { configurationId },
    );
    return this.common.getJSON(url, { credentials: 'include' });
  }

  async cancelAppointment(
    appointmentId: string,
    patientEhrId: string,
    configurationId: string,
  ): Promise<{ success: boolean }> {
    const url = this.common.constructPath(
      `/patient-previsit/appointments/${appointmentId}`,
      { patientEhrId, configurationId },
    );
    return this.common.deleteJSON(url);
  }
}
